// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"71bde1a0fe2e1fb9","src_app_auth_auth_module_ts":"6c03adeccb3cb473","src_app_teacher_teacher_module_ts":"82b37044ba239e44"}[chunkId] + ".js";
};